// eslint-disable-next-line @typescript-eslint/no-explicit-any
let mocks = new WeakMap();
let usingTestingFramework = 'jasmine' in window || 'jest' in window || navigator.userAgent.includes('jsdom');
/**
 * Internal function use to change the detection of Testing frameworks to allow testing of the package
 * @internal
 * @param value - Defines if the package will detect as running in a testing framework
 */
export function setTestEnvironment(value) {
    usingTestingFramework = value;
}
/**
 * Gets an element based on `thing` reference, if the element is stubbed, the stub will be returned.
 * If not the reference will be returned.
 * @public
 * @param thing - Reference object
 * @typeParam TThing - Type of the object being injected
 * @returns Stub or reference
 */
export function get(thing) {
    if (!usingTestingFramework) {
        return thing;
    }
    return mocks.get(thing) || thing;
}
/**
 * Stub reference `thing` with `stubElement`.
 * @public
 * @param thing - Object to stub.
 * @param stubElement - Object that will be return now forward when `thing` is requested.
 * @typeParam TThing - Type of the object being stubbed
 * @typeParam TStub - Type of the object that will replace `thing`
 * @returns `stubElement` element.
 */
export function stub(thing, stubElement) {
    if (!usingTestingFramework) {
        throw new Error('External injector must `stub` function must only be used on testing specs.');
    }
    if (mocks.has(thing)) {
        mocks.delete(thing);
    }
    mocks.set(thing, stubElement);
    return stubElement;
}
/**
 * Remove one stub given the reference object
 * @public
 * @param thing - Object that was stub
 * @typeParam TThing - Type of the object being restored
 * @returns undefined
 */
export function restore(thing) {
    if (mocks.has(thing)) {
        mocks.delete(thing);
    }
}
/**
 * Clean all stubs
 * @public
 * @returns undefined
 */
export function restoreAll() {
    mocks = new WeakMap();
}
